import { pluralizedUnitOptions } from '@components/shared/UnitSelect/pluralizedUnitOptions';
import { EventSeriesCadenceUnit } from 'types/EventSeries';

// Cadence is a free integer, interpreted in one of the units below. These
// bounds are enforced both client-side (numeric inputs) and server-side.
export const MIN_CADENCE = 1;
export const MAX_CADENCE_DAYS = 3650; // ~10 years
export const MAX_CADENCE_WEEKS = 520;
export const MAX_CADENCE_MONTHS = 120;
export const MAX_CADENCE_YEARS = 10;

export const MAX_CADENCE_BY_UNIT: Record<EventSeriesCadenceUnit, number> = {
  days: MAX_CADENCE_DAYS,
  months: MAX_CADENCE_MONTHS,
  weeks: MAX_CADENCE_WEEKS,
  years: MAX_CADENCE_YEARS,
};

export const CADENCE_UNITS: readonly EventSeriesCadenceUnit[] = ['days', 'weeks', 'months', 'years'];

export const CADENCE_UNIT_OPTIONS = (
  t: (key: string, opts?: object) => string,
  count?: number | null,
): { label: string; value: EventSeriesCadenceUnit }[] =>
  pluralizedUnitOptions(CADENCE_UNITS, 'general.unit_', count, t);
